export default __webpack_public_path__ + "static/media/else_lowdef.c2bc92cd.png";